import React from 'react'
import { SxProps } from '@mui/material'
import { Button, Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

export interface LoadingButtonProps {
  disabled?: boolean;
  loading?: boolean;
  buttonStyle?: SxProps;
  loadingStyle?: SxProps;
  children?: React.ReactNode | string;
  onClick?: () => void;
}

export const LoadingButton: React.FC<LoadingButtonProps> = (props) => {
  const { disabled, loading, buttonStyle, loadingStyle, children, onClick } =
    props
  return (
    <Box sx={{ position: 'relative' }}>
      <Button
        variant="contained"
        sx={{ minWidth: 112, borderRadius: '4px', ...buttonStyle }}
        disabled={disabled || loading}
        onClick={onClick}
      >
        {children}
      </Button>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            color: 'rgba(0,0,0,0.2)',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
            ...loadingStyle,
          }}
        />
      )}
    </Box>
  )
}
